import { useState } from 'react'
import type { BrainSynonym } from '../types'

type Props = {
  items: BrainSynonym[]
  busy: boolean
  error?: Error | null
  onCreate: (item: BrainSynonym) => void
  onUpdate: (item: BrainSynonym) => void
  onDelete: (id: string) => void
}

const fields = ['CATEGORY', 'SUBCATEGORY', 'COLOR', 'STYLE', 'SHAPE', 'MATERIAL', 'PRICE_PREFERENCE', 'INTENT', 'SORT']
const empty: BrainSynonym = { phrase: '', targetField: 'STYLE', targetValue: '', enabled: true }

export function BrainSynonyms({ items, busy, error, onCreate, onUpdate, onDelete }: Props) {
  const [draft, setDraft] = useState<BrainSynonym>(empty)
  const submit = () => {
    if (!draft.phrase.trim() || !draft.targetValue.trim()) return
    if (draft.id) onUpdate(draft)
    else onCreate(draft)
    setDraft(empty)
  }
  return <section className="panel">
    <div className="panel-heading"><div><span className="eyebrow">VOCABULÁRIO DO TENANT</span><h2>Sinônimos comerciais</h2><p>Mapeie a linguagem real do cliente para categorias e atributos oficiais.</p></div></div>
    <div className="brain-synonym-form">
      <label>Como o cliente fala<input value={draft.phrase} onChange={(event) => setDraft({ ...draft, phrase: event.target.value })} placeholder="Ex.: em conta" /></label>
      <label>Campo<select value={draft.targetField} onChange={(event) => setDraft({ ...draft, targetField: event.target.value })}>{fields.map((field) => <option key={field} value={field}>{field}</option>)}</select></label>
      <label>Valor oficial<input value={draft.targetValue} onChange={(event) => setDraft({ ...draft, targetValue: event.target.value.toUpperCase() })} placeholder="LOW_PRICE" /></label>
      <label className="brain-inline-toggle"><input type="checkbox" checked={draft.enabled} onChange={(event) => setDraft({ ...draft, enabled: event.target.checked })} /> Ativo</label>
      <div className="row-actions"><button className="primary-button" type="button" disabled={busy || !draft.phrase.trim() || !draft.targetValue.trim()} onClick={submit}>{draft.id ? 'Atualizar' : 'Adicionar'}</button>{draft.id && <button className="secondary-button" type="button" onClick={() => setDraft(empty)}>Cancelar</button>}</div>
    </div>
    {error && <div className="error-banner">{error.message}</div>}
    {items.length === 0 ? <div className="empty-state">Nenhum sinônimo customizado. O motor continuará usando o vocabulário padrão.</div> : <div className="brain-card-list">{items.map((item) => <article key={item.id} className="brain-list-card"><div><strong>{item.phrase}</strong><small>{item.targetField} → {item.targetValue}</small></div><span className={item.enabled ? 'status-pill success' : 'status-pill neutral'}>{item.enabled ? 'Ativo' : 'Inativo'}</span><div className="row-actions"><button className="secondary-button" type="button" onClick={() => setDraft(item)}>Editar</button><button className="danger-button" type="button" onClick={() => item.id && onDelete(item.id)}>Excluir</button></div></article>)}</div>}
  </section>
}
